import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from 'react-redux'
import { Redirect, useParams } from 'react-router-dom'
import { updateBanner, updateStatusBanner, updateBlogBanner, APIpath, updateBannerImage } from '../actions'
import { getBanner, getRedirect } from '../reducers'
import {
    Box,
    FormControl,
    FormLabel,
    Input,
    FormErrorMessage,
    Button,
    CircularProgress,
    useColorModeValue,
    Select,
    Card,
    Radio, RadioGroup,
    HStack,
    Image
} from '@chakra-ui/react'
import { Formik, Field } from 'formik'
import { FormValidator } from '../utils/validationForms'
import Layout from '../layout'
import InputFile from "../components/InputFile"
import placeholder from '../multimedia/placeholder.jpg'
import Editor from "../components/Editor"
import "../styles.css"
import design1 from '../multimedia/design1.jpg'
import design2 from '../multimedia/design2.jpg'
import design3 from '../multimedia/design3.jpg'
import design4 from '../multimedia/design4.jpg'
import design5 from '../multimedia/design5.jpg'

const replaceImage = (error) => {
    error.target.src = placeholder;
}

const ConfigurationBannerEdit = () => {

    const [html, setHTML] = useState("")
    const [mounted, setMounted] = useState(false)
    const [editor, setEditor] = useState(null)
    const [editorSetted, setEditorSetted] = useState(false)
    const dispatch = useDispatch()
    const redirect = useSelector(state => getRedirect(state))

    const [banner_id] = useState(useParams("id").id)
    const banner = useSelector(state => getBanner(state, banner_id))
    const color = useColorModeValue('white', 'gray.800')

    useEffect(() => {
        setHTML(banner.text)
        setMounted(true)
    }, [])

    if (redirect) {
        return <Redirect to="/config/banner" />
    }

    return (
        <Layout>

            <Box w={'full'} bg={color} rounded={'md'} m={3} p={6} >

                <h1>Cambio de imagen</h1>
                <hr />
                <br />
                <Formik
                    initialValues={{
                        image: null
                    }}
                    validate={values => FormValidator([
                        { field: 'image', value: values.image, rules: ['required'] },
                    ])}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        setSubmitting(true)
                        const formData = new FormData()
                        for (let value in values) {
                            formData.append(value, values[value])
                        }
                        formData.append('id', banner.id)
                        Promise.resolve(dispatch(updateBannerImage(formData, banner.id)))
                            .then(() => {
                                setSubmitting(false)
                                resetForm()
                            })
                    }}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                        <form onSubmit={handleSubmit}>

                            <Image src={`${APIpath}/banner/image/${banner.id}?${Math.random().toString(36)}`} alt={"preview" + banner.id} key={banner.id} h={"200px"} w={"auto"} m={"auto"} onError={replaceImage} />

                            <FormControl isInvalid={errors.image && touched.image}>
                                <FormLabel>Imagen</FormLabel>
                                <InputFile name={"image"} label={"Imagen"} setFieldValue={setFieldValue} value={values.image} />
                                <FormErrorMessage>{errors.image}</FormErrorMessage>
                            </FormControl>


                            <Button colorScheme="teal" variant="outline" type="submit" mt={4} disabled={isSubmitting}>
                                {isSubmitting ? <CircularProgress /> : 'Actualizar'}
                            </Button>
                        </form>
                    )}
                </Formik>
            </Box>

            <Box w={'full'} bg={color} rounded={'md'} m={3} p={6} >
                <h1>Cambio de informacion</h1>
                <hr />
                <br />
                <Formik
                    initialValues={{
                        title: banner.title || '',
                        buttonUrl: banner.buttonUrl || '',
                        buttonText: banner.buttonText,
                        design: `${banner.design}`,
                        colorDesign: banner.colorDesign,
                    }}
                    validate={values => FormValidator([
                        { field: 'titulo', value: values.title, rules: ['required'] },
                        { field: 'diseño', value: values.design, rules: ['required'] },
                        { field: 'color diseño', value: values.colorDesign, rules: ['required'] },
                        { field: 'Texto Call to action', value: values.buttonText, rules: ['required'] },
                    ])}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        setSubmitting(true)
                        const formData = new FormData()
                        for (let value in values) {
                            formData.append(value, values[value])
                        }
                        formData.append('id', banner.id)
                        formData.append('text', html)
                        Promise.resolve(dispatch(updateBanner(formData, banner.id)))
                            .then(() => {
                                setSubmitting(false)
                                resetForm()
                            })
                    }}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                        <form onSubmit={handleSubmit}>

                            <FormControl isInvalid={errors.title && touched.title}>
                                <FormLabel>Titulo</FormLabel>
                                <Input name="title" onChange={handleChange} onBlur={handleBlur} value={values.title} />
                                <FormErrorMessage>{errors.title}</FormErrorMessage>
                            </FormControl>

                            <FormLabel>Contenido</FormLabel>
                            <Card>
                                {mounted ?
                                    <Editor placeholder={"Contenido"} setHTML={setHTML} setEditor={setEditor} initialHtml={html} setEditorSetted={setEditorSetted} editorSetted={editorSetted} />
                                    : <>Loading</>
                                }
                            </Card>

                            <br />

                            <FormControl isInvalid={errors.buttonText && touched.buttonText}>
                                <FormLabel>Texto Call to action</FormLabel>
                                <Input name="buttonText" onChange={handleChange} onBlur={handleBlur} value={values.buttonText} />
                                <FormErrorMessage>{errors.buttonText}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={errors.buttonUrl && touched.buttonUrl}>
                                <FormLabel>URL Call to action</FormLabel>
                                <Input name="buttonUrl" onChange={handleChange} onBlur={handleBlur} value={values.buttonUrl} />
                                <FormErrorMessage>{errors.buttonUrl}</FormErrorMessage>
                            </FormControl>

                            <FormControl as='fieldset' isInvalid={errors.design && touched.design}>
                                <FormLabel as='legend'>Diseño</FormLabel>
                                <RadioGroup value={values.design} onChange={handleChange} spacing='24px' name="design">
                                    <HStack spacing='24px'>
                                        <Field colorScheme="easycar1" as={Radio} value={"1"} >
                                            <Image src={design1} width={"100px"} />
                                        </Field>
                                        <Field colorScheme="easycar1" as={Radio} value={"2"} >
                                            <Image src={design2} width={"100px"} />
                                        </Field>
                                        <Field colorScheme="easycar1" as={Radio} value={"3"} >
                                            <Image src={design3} width={"100px"} />
                                        </Field>
                                        <Field colorScheme="easycar1" as={Radio} value={"4"} >
                                            <Image src={design4} width={"100px"} />
                                        </Field>
                                        <Field colorScheme="easycar1" as={Radio} value={"5"} >
                                            <Image src={design5} width={"100px"} />
                                        </Field>
                                    </HStack>
                                </RadioGroup>
                                <FormErrorMessage>{errors.design}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={errors.colorDesign && touched.colorDesign}>
                                <FormLabel>Color Diseño</FormLabel>
                                <Select name="colorDesign" onChange={handleChange} onBlur={handleBlur} value={values.colorDesign}>
                                    <option value={1} > Verde</option>
                                    <option value={2} > Gris</option>
                                    <option value={3} > Blanco</option>
                                </Select>
                                <FormErrorMessage>{errors.colorDesign}</FormErrorMessage>
                            </FormControl>

                            <Button colorScheme="teal" variant="outline" type="submit" mt={4} disabled={isSubmitting}>
                                {isSubmitting ? <CircularProgress /> : 'Actualizar'}
                            </Button>
                        </form>
                    )}
                </Formik>

            </Box>

            <Box w={'full'} bg={color} rounded={'md'} m={3} p={6} >
                <h1>Estado de banner</h1>
                <hr />
                <br />
                <Button onClick={() => {
                    dispatch(updateStatusBanner(banner.id))
                }} colorScheme="easycar2" type="submit" mt={4} > {banner.active ? "Ocultar" : "Activar"} </Button>
            </Box>


            <Box w={'full'} bg={color} rounded={'md'} m={3} p={6} >
                <h1>Banner para blog</h1>
                <hr />
                <br />
                <Button onClick={() => {
                    dispatch(updateBlogBanner(banner.id))
                }} colorScheme="easycar2" type="submit" mt={4} > {banner.banner_blog ? "Ocultar" : "Activar"} </Button>
            </Box>
        </Layout >
    )
}

export default ConfigurationBannerEdit
